module.exports = __webpack_public_path__ + "static/img/logo.9457e64e.png";